import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import { Container, Row } from 'react-bootstrap'

import Slider from '@shared/components/slider'
import useWindowSize from '@shared/hooks/windowSize'
import TrendingPlayerCard from '../trendingPlayerCard'

export default function PopularPlayers({ popularTeams }) {
  const [width] = useWindowSize()
  return (
    <div className={styles.popularTeams}>
      <Container>
        <Row>
        <h4 className={`${styles.title} mb-3`}>Trending Players</h4>
        </Row>
        <Row>
        <Slider nav gap={width > 767 ? 16 : 8} destroyBelow={2200} customNextArrow={styles.customNextArrow}
          customPrevArrow={styles.customPrevArrow}>
            {popularTeams?.map((player, i) => {
              return <TrendingPlayerCard data={player} key={player?.sName + '_' + i} />
            }
            )}
        </Slider>
        </Row>
      </Container>
    </div>)
}

PopularPlayers.propTypes = {
  popularTeams: PropTypes.array
}
